import { ESharedFunction } from "motw_core/Enums/ESharedFunction";
import * as React from "react";
import { IPhrasingState } from "source/app/presentation/MainPanel/LifeChangingEvents/UnderDevelopment/Phrasing/Phrasing";
import { FormSelect } from "source/app/presentation/Shared/Form/Select/FormSelect";
import { FormTextArea } from "source/app/presentation/Shared/Form/TextArea/FormTextArea";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import { StyleClass } from "source/app/presentation/Shared/Styles/CSS";
import IconWithText from "source/app/services/Shared/IconWithText/IconWithText";
import { ReadState } from "source/app/services/UI/State/ReadState";
import { SetState } from "source/app/services/UI/State/SetState";
import UI from "source/app/services/UI/UI";

export function PhrasingBody() {
    const state = ReadState<IPhrasingState>(ESharedFunction.Phrasing_state);

    if (!state) {
        return null;
    }

    const setState = (newState: Partial<IPhrasingState>) =>
        SetState<IPhrasingState>(ESharedFunction.Phrasing_state, newState);

    return (
        <div>
            <div>
                <FormSelect
                    width="75px"
                    id="clickTarget_phrasingBodyPart"
                    onChange={(event) => {
                        setState({ bodyPart: event.target.value });
                    }}
                    suggestions={[
                        "head",
                        "eyes",
                        "neck",
                        "nose",
                        "throat",
                        "chest",
                        "gut",
                        "knees",
                        "feet",
                        "lips",
                        "shoulders",
                    ]}
                    value={state.bodyPart}
                />
                <FormSelect
                    width="40px"
                    id="phrasingBodyDifficulty"
                    onChange={(event) =>
                        setState({
                            bodyDifficulty: Number.parseInt(event.target.value),
                        })
                    }
                    suggestions={[1, 2, 3, 4, 5, 6, 7, 8, 9].map((v) =>
                        v.toString()
                    )}
                    value={state.bodyDifficulty}
                    onEnter={() => Book(setState, state)}
                />
                <IconWithText
                    iconSuffix={EGlyphicon.ok}
                    whenClicked={() => Book(setState, state)}
                    displayAsBlock={false}
                    withClass={StyleClass(`phrasingBodyBookLink`, {
                        opacity: 0.6,
                        marginLeft: `10px`,
                    })}
                >
                    Book
                </IconWithText>
            </div>
            <IconWithText
                iconSuffix={EGlyphicon["ban-circle"]}
                whenClicked={() => {
                    setState({ headerProblem: "", bodyTexts: [] });
                    UI.FocusOnElement("clickTarget_phrasingHeaderProblem");
                }}
                displayAsBlock
                withClass={StyleClass(`phrasingBodyClearLink`, {
                    opacity: 0.6,
                    margin: `15px`,
                })}
            >
                Clear
            </IconWithText>
        </div>
    );
}

function Book(
    setState: (newState: Partial<IPhrasingState>) => Promise<void>,
    state: IPhrasingState
) {
    {
        const newBodyTexts = [...state.bodyTexts];

        let lastBodyText = newBodyTexts[newBodyTexts.length - 1];
        lastBodyText = `${lastBodyText} ${state.bodyPart} ${state.bodyDifficulty}`;
        newBodyTexts[newBodyTexts.length - 1] = lastBodyText;

        setState({
            bodyTexts: newBodyTexts,
        });

        // This doesn't work properly on iOS so commented out
        // document.getElementById("clickTarget_phrasingBodyPart")?.focus();
    }
}
